module.exports = __webpack_public_path__ + "img/comic4.jpg";